import React, { Component } from 'react';
import './profile.css';


function ProfileRedeem (props){

  return(
    <h1 className="main-h1 profile-h1">Gift Cards...Redeem!</h1>
)
}






export default ProfileRedeem;



// WEBPACK FOOTER //
// ./src/profileredeem.js